import { useEffect, useState } from "react";
import { AccessContext, normalizeAccessContext } from "../services/accessContext";

declare global {
  interface Window {
    accessContext?: unknown;
  }
}

export const readAccessContext = (): AccessContext => normalizeAccessContext(window.accessContext);

// The host sets window.accessContext after getUserByToken and fires 'accessContext' when it changes.
export const useAccessContext = (): AccessContext => {
  const [ctx, setCtx] = useState<AccessContext>(readAccessContext);
  useEffect(() => {
    const onChange = (event: Event) =>
      setCtx(normalizeAccessContext((event as CustomEvent).detail ?? window.accessContext));
    document.addEventListener("accessContext", onChange);
    setCtx(readAccessContext());
    return () => document.removeEventListener("accessContext", onChange);
  }, []);
  return ctx;
};
